import { createAsyncActionType } from './index';

export const EVENT_DATES_LIST_GET = createAsyncActionType(
  'events',
  'EVENT_DATES_LIST_GET'
);

export const SESSIONS_LIST_GET = createAsyncActionType(
  'events',
  'SESSIONS_LIST_GET'
);
export const SESSIONS_LIST_RESET = '@@events/SESSIONS_LIST_RESET';

export const EVENT_DETAILS_GET = createAsyncActionType(
  'events',
  'EVENT_DETAILS_GET'
);
export const EVENT_DETAILS_RESET = '@@events/EVENT_DETAILS_RESET';

export const SESSION_REGISTRATION_SET = createAsyncActionType(
  'events',
  'SESSION_REGISTRATION_SET'
);

export const CHECK_EVENT_TUTOR = createAsyncActionType(
  'events',
  'CHECK_EVENT_TUTOR'
);

export const GET_USERS_BY_SESSION = createAsyncActionType(
  'events',
  'GET_USERS_BY_SESSION'
);

export const ADD_USER_TO_SESSION = createAsyncActionType(
  'events',
  'ADD_USER_TO_SESSION'
);

export const JOIN_BBB_SESSION = createAsyncActionType(
  'events',
  'JOIN_BBB_SESSION'
);

export const RESET_BBB_SESISON = '@@events/RESET_BBB_SESISON';

export const BBB_ENABLED_GET = createAsyncActionType(
  'events',
  'BBB_ENABLED_GET'
);

export const BBB_URL_GET = createAsyncActionType('events', 'BBB_URL_GET');
